import { createRoot } from 'react-dom/client'
import './styles.css'
import App from './App'

/*
auto-generated by: https://github.com/pmndrs/gltfjsx
author: ar-watches (https://sketchfab.com/ar-watches)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/tag-heuer-monaco-x-gulf-watch-31ba7140fb3146b2af3cbdc13022421c
title: Tag Heuer Monaco X GULF Watch
*/

/**
 * Original Watch demo by Paul Henschel
 * https://codesandbox.io/u/drcmda
 */

createRoot(document.getElementById('root')).render(
  <>
    <App />
  </>
)
